import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProfileService } from '../../../../services/profile.service';
import { users } from '../../../../interfaces/users';

import { OrdersService } from '../../../../services/orders';
@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrl: './invoice.component.scss'
})
export class InvoiceComponent {
  userData!: users;
  data!: any;
  invoiceId!: any;
  userid!: any;
  date!: any;
  pagename!: any;
  userimage!: any;
  userphone!: any;
  facebook!: any;
  instagram!: any;
  tiktok!: any;
  note!: any;
  clientname!: any;
  firstphone!: any;
  delivery_hero!: any;
  secphone!: any;
  address!: any;
  products!: any;
  qty!: any;
  prices!: any;
  deliveryfees!: any;
  discount!: any;
  sumprices!: any;
  contentReady: boolean = true;
  qrPath!: any;
  link!: any;
  translateList: any = [];
  constructor(
    private _profileService: ProfileService,
    private _orderService: OrdersService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.contentReady = true;
    this.route.queryParams.subscribe(params => {
      this.data = params;
      if (this.data["note"] !== "undefined") {
        this.note = this.data["note"];

      }
      else {
        this.note = "no note";
      }

      this.invoiceId = this.data["id"];
      this.date = this.convertDate(this.data["created_at"]);
      this.clientname = this.data["client_name"];
      this.firstphone = this.data["phone_number"];
      this.secphone = this.data["another_phone"];
      this.address = this.data["address"];
      this.userid = this.data["user_id"];
      this.deliveryfees = parseInt(this.data["delivery_fees"]);
      this.qty = String(this.data['quantity']).split(",");
      this.prices = String(this.data['price']).split(",");
      this.products = String(this.data['item']).split(",");
      this.delivery_hero = this.data["delivery_hero"];
      this.discount = isNaN(parseInt(this.data["discount"])) ? 0 : parseInt(this.data["discount"])
      this.sumprices = this.sumArray(this.prices);
      // The data is available here
    });
    this.getUserItems();

  }

  sumArray(array: any[]): number {
    let fixedArray = [];
    for (let i = 0; i < array.length; i++) {
      // Assuming 'array' is an array of objects, e.g., [{ price: '10', qty: '2' }, ...]
      fixedArray.push(parseInt(this.prices[i]) * parseInt(this.qty[i])); // Assuming `price` and `qty` are properties of the objects
    }

    // Sum the values and return the total
    return fixedArray.reduce((sum: number, value: number) => sum + value, 0);
  }
  convertDate(dateString: any) {
    // Create a new Date object from the input date string
    const date = new Date(dateString);

    // Extract the day, month, and year
    const day = ('0' + date.getDate()).slice(-2);  // Add leading zero if needed
    const month = ('0' + (date.getMonth() + 1)).slice(-2);  // Month is 0-indexed, add 1
    const year = date.getFullYear();

    // Return the formatted date as "dd-MM-yyyy"
    return `${day}-${month}-${year}`;
  }
  getUserItems() {

    this._profileService.getuserinfo(this.userid).subscribe({
      next: (res) => {

        this.userData = res;

        this.pagename = this.userData.last_name;
        this.facebook = this.removeHttps(this.userData.facebook_link);
        this.instagram = this.removeHttps(this.userData.instagram_link);
        this.tiktok = this.removeHttps(this.userData.tiktok_link);

        this.userphone = this.userData.phone;
        console.log(this.userimage)
        if (this.userData.image == null || this.userData.image == "https://backendtesting.blueboxpet.com/public/uploads/users/" || this.userData.image == "public/storage/" || this.userData.image == "undefined" || this.userData.image == undefined)
          this.userimage = "assets/logo-01.png";
        else
          this.userimage = this.changeUrl(this.userData.image);

        this.contentReady = false;
      },
      error: (err) => alert("error"),
    });

  }
  changeUrl(url: string): string {
    return url.replace('/storage', '');
  }
  removeHttps(url: any) {
    if (url != null) {
      if (url.startsWith('https://')) {
        return url.substring(8); // Remove the first 8 characters ('https://')
      }
      return url; // Return the original URL if it doesn't start with 'https://'
    }
  }
  createList(e: any) {
    this.translateList.push(String(e));
    console.log(this.translateList)
  }
  fixImageUrl(image: string) {
    if (!image) return '';

    // هيفصل الباث حسب "/" وياخد آخر جزء
    const fileName = image.split('/').pop();

    return "https://backendtesting.blueboxpet.com/storage/app/public/qrcodes/links/" + fileName;
  }

}
